import { useState } from 'react'
import { useNavigate, Navigate, useLocation } from 'react-router-dom'
import { login, auth } from '../lib/api.js'

export default function Login() {
  const nav = useNavigate()
  const home = useLocation().state?.back === '/screen' ? '/screen' : '/workbench'
  const [id, setId] = useState('')
  const [pw, setPw] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(e) {
    e?.preventDefault()
    setErr(''); setBusy(true)
    try {
      await login(id.trim(), pw)
      nav(home, { replace: true })
    } catch (e) {
      setErr(e.message); setBusy(false)
    }
  }

  // 已登录直接跳工作台。要用 <Navigate> 而不是在渲染期间调 nav()：后者 React 会报「渲染时更新别的组件」
  if (auth.token) return <Navigate to={home} replace />

  return (
    <div className="login-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <form className="card" onSubmit={submit} style={{ padding: 32, width: '100%', maxWidth: 360 }}>
        <div style={{ fontSize: 22, fontWeight: 600 }}>ETC 运营系统</div>
        <div className="muted small" style={{ marginTop: 4, marginBottom: 24 }}>请使用运营账号登录</div>

        <div className="field">
          <label>账号</label>
          <input className="input" value={id} onChange={e => setId(e.target.value)} autoFocus autoComplete="username" />
        </div>
        <div className="field">
          <label>密码</label>
          <input className="input" type="password" value={pw} onChange={e => setPw(e.target.value)} autoComplete="current-password" />
        </div>
        <div className="err">{err}</div>
        <button className="btn btn-primary" style={{ width: '100%', marginTop: 8 }} disabled={busy}>
          {busy ? '登录中…' : '登录'}
        </button>
      </form>
    </div>
  )
}
